import { Link } from "react-router-dom";

const subcategories = [
  {
    id: 1,
    title: "Reading\nCorners",
    text: "Soft armchairs, good light, and a shelf of favorite books.",
    button: "View Reading Corners",
    path: "/cozy-corners/reading-corner",
    image: "https://public.readdy.ai/ai/img_res/2554fb91bc8cdea7e279349ae73462ec.jpg",
  },
  {
    id: 2,
    title: "Best Beige\nSofas",
    text: "Calm, comfortable, and built to last — the best beige sofas for a warm living room.",
    button: "Browse Beige Sofas",
    path: "/cozy-corners/best-beige-sofas",
    image: "https://readdy.ai/api/search-image?query=beige%20linen%20sofa%20living%20room%20warm%20neutral%20tones%20soft%20cushions%20natural%20light%20wood%20coffee%20table%20calm%20elegant%20editorial%20interior%20photography%20portrait&width=800&height=1000&seq=cc_sub2b&orientation=portrait",
  },
  {
    id: 3,
    title: "Small Space\nCalm",
    text: "Making small corners feel peaceful, intentional, and beautifully yours.",
    button: "Discover Small Spaces",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=small%20cozy%20corner%20calm%20space%20minimal%20decor%20warm%20lamp%20soft%20cushion%20plants%20books%20cream%20beige%20warm%20neutral%20tones%20intimate%20editorial%20photography%20portrait%20interior&width=800&height=1000&seq=cc_sub3&orientation=portrait",
  },
];

export default function CCSubcategories() {
  return (
    <section className="py-24 px-8 md:px-16 max-w-screen-xl mx-auto">
      <div className="text-center mb-16">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Browse by Corner
        </p>
        <h2
          className="text-[#2C2825] text-3xl md:text-4xl"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Find Your Corner
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {subcategories.map((sub) => (
          <div key={sub.id} className="group flex flex-col">
            <div className="relative overflow-hidden rounded-2xl bg-[#F5F1E8] aspect-[3/4] mb-6">
              <img
                src={sub.image}
                alt={sub.title.replace("\n", " ")}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              <div className="absolute top-5 right-5">
                <span
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#FAF7F0]/80 text-[#6B5E53] text-xs font-medium"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  0{sub.id}
                </span>
              </div>
            </div>

            <div className="flex flex-col flex-1">
              <h3
                className="text-[#2C2825] text-xl md:text-2xl leading-snug mb-3 whitespace-pre-line"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {sub.title}
              </h3>
              <p
                className="text-[#8B8378] text-sm leading-relaxed mb-6 flex-1"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
              >
                {sub.text}
              </p>
              <Link
                to={sub.path}
                className="self-start inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-6 py-2.5 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {sub.button}
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[10px]" />
                </span>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
